<template>
  <div>
    <v-container>

      <v-form v-model="formValid" ref="inviteForm">

        <v-layout align-center>
          <v-btn
            @click.prevent="registAccount"
            :disabled="!formValid"
            :class="!formValid?'grey lighten-1':userRole==rootRoleName?'red darken-3':'primary'" small
          >
            <span v-if="userRole==rootRoleName">P/C ルートアカウントの発行 (メールの送信)</span>
            <span v-else>{{$t("account.invite-btn")}}</span>
          </v-btn>

          <span class="blue--text">
          {{$t('account.csv-import')}}
          </span>
        </v-layout>

        <v-divider></v-divider>


        <v-layout row wrap>
          <v-flex xs12 sm6 lg3 class="pa-3">
            <v-text-field
              :label="$t('user-params.username')"
              v-model="edit.username"
              :rules="usernameRules"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 lg3 class="pa-3">
            <v-text-field
              :label="$t('user-params.email')"
              v-model="edit.email"
              :rules="emailRules"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm5 lg3 class="pa-3">
            <v-select
              :label="$t('account.label-role')"
              v-model="edit.roleId"
              :items="roles"
              item-text="name"
              item-value="id"
              :rules="[v => !!v || $t('account.vali-role')]"
              required
              :disabled="userRole==rootRoleName"
              :hint="userRole==rootRoleName?'root account can only make admin role':''"
              persistent-hint
            ></v-select>
          </v-flex>

          <v-flex  xs12 sm5 lg3 class="pa-3">
            <v-select
              :label="$t('account.label-belongto')"
              v-model="edit.organizationId"
              :items="organizations"
              item-text="name"
              item-value="organizationId"
              :rules="[v => !!v || $t('account.vali-org-select')]"
              required
              auto
              :hint="userRole==rootRoleName?'root account can make accounts under the child organization only.':''"
              persistent-hint
            ></v-select>
            <visible-locations-set v-if="edit.roleId===8&&edit.organizationId"
              :editProp="edit" @child-action="setViewerPermission"
            />
          </v-flex>
        </v-layout>
      </v-form>


      <!-- errors -->
      <div v-if="errorMessage" class="red--text" >
        <strong>{{errorMessage}}</strong>
      </div>

      <!-- success dialog -->
      <v-snackbar
        :timeout="5000"
        v-model="showSnackbar"
        absolute top right
        color="teal lighten-2"
        multi-line
      >
    {{$t('account.success-dialog')}} <br/>
    {{successMessage}}
    </v-snackbar>
  </v-container>
  </div>
</template>

<script>
import config from '@/config.js'
import http from '@/utils/http.js'
import utils from '@/utils/utils.js'
import validate from '@/utils/validate.js'
import VisibleLocationsSet from '@/components/AccountVisibleLocationsSetDialog.vue'

export default {
  components: {
    VisibleLocationsSet
  },
  data () {
    return {
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: config.role.Root,
      edit: {
        organizationId: '',
        username: '',
        password: '',
        email: '',
        roleId: '',
        acceptance: false,
        locations: []
      },
      organizations: [],
      roles: [],
      policyStatement: '',
      policyStatementLanguage: '',
      policyStatementversion: 0,
      errorMessage: '',
      successMessage: '',
      showDialog: false,
      showSnackbar: false,
      // バリデーションルール
      formValid: true,
      usernameRules: [
        v => !!v || this.$t('account.vali-username-must'),
        v => /^[A-Za-z0-9.\-_@]+$/.test(v) || this.$t('account.vali-username-format'),
        v => (v && v.length <= 20 && v.length >= 4) || this.$t('account.vali-username-char')
      ],
      emailRules: [
        v => !!v || this.$t('account.vali-email-must'),
        v => validate.emailFormat(v) ||
           this.$t('account.vali-email-format')
      ],
      domain: ''
    }
  },
  computed: {
    editRoleOrganization: function () {
      return {roleId: this.edit.roleId, organizationId: this.edit.organizationId}
    }
  },
  watch: {
    editRoleOrganization: {
      handler: function (val, prev) {
        if (val.roleId !== '' && val.organizationId &&
          (val.roleId !== prev.roleId || val.organizationId !== prev.organizationId)) {
          this.edit.accountGroupResourceIds = {viewLocation: []}
        }
      },
      deep: true
    }
  },
  methods: {
    init () {
      this.getOrganizations()
      this.roles = this.getRoles(this.userRole)
      this.getPolicyStatement()
      this.getDomainConfig()
    },
    getOrganizations () {
      http.request('get', '/service2/dashboard/api/Organizations/organizationList')
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get organization list failed. (' + data.result + ')')
            return
          }
          this.organizations = data.organizations

          // Rootアカウントの場合、直下しか見せないようにする
          if (this.userRole === config.role.Root) {
            console.log('here now root')
            let organizationsWhenRoot = this.organizations.filter((organization) => {
              return organization.depth === '1'
            })
            this.organizations = organizationsWhenRoot
            this.edit.roleId = 2 // ハードコード
          }
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    getRoles (role) {
      const viewerLabel = 'Viewer' + ' (' + this.$t('viewable-locations.select-is-not-limited-viewer') + ')'
      const limitedViewerLabel = 'Viewer' + ' (' + this.$t('viewable-locations.select-is-limited-viewer') + ')'
      // ここはハードコード
      switch (role) {
        case config.role.Root:
          return [{id: 2, name: 'Administrator'}]
        case config.role.Administrator:
          return [{id: 2, name: 'Administrator'}, {id: 3, name: 'Manager'}, {id: 4, name: 'Staff'}, {id: 7, name: viewerLabel}, {id: 8, name: limitedViewerLabel}]
        case config.role.Manager:
          return [{id: 3, name: 'Manager'}, {id: 4, name: 'Staff'}, {id: 7, name: viewerLabel}, {id: 8, name: limitedViewerLabel}]
        case config.role.Staff:
          return [{id: 7, name: viewerLabel}, {id: 8, name: limitedViewerLabel}]
        case config.role.Viewer:
          return []
        default:
          return []
      }
    },
    getPolicyStatement () {
      http.request('post', '/service2/dashboard/api/policyStatements/getStatement', {language: 'English'})
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get policy statement failed. (' + data.result + ')')
            return
          }
          this.policyStatement = data.statement.statement
          this.policyStatementLanguage = data.statement.language
          this.policyStatementVersion = data.statement.maxVersion
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    setViewerPermission (edit) {
      this.edit = JSON.parse(JSON.stringify(edit))
    },
    registAccount () {
      this.showDialog = false
      let roleId = this.edit.roleId
      const params = {
        organizationId: this.edit.organizationId,
        username: this.edit.username,
        generatedUuid: utils.generateUuid(),
        password: this.edit.password,
        email: this.edit.email,
        roles: [roleId],
        accountGroupResourceIds: this.edit.accountGroupResourceIds || {viewLocation: []},
        acceptance: true, // checkboxからAgreeボタンに変更
        language: this.policyStatementLanguage,
        version: this.policyStatementVersion,
        domain: this.domain
      }
      http.request('post', '/service2/dashboard/api/Accounts/register', params)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('regist account data failed. (' + data.result + ')')
            this.showError(data.result)
            return
          }

          this.showSnackbar = true
          this.errorMessage = ''
          this.successMessage = this.edit.email
          this.$refs.inviteForm.reset()
          // this.$router.push('/settings/user_invite')
          this.edit.accountGroupResourceIds = {viewLocation: []}
        })
        .catch(error => {
          console.log('error', error)
          if (error.response.status === 403) {
            this.showError(this.$store.getters.message.message)
          } else {
            this.showError(error)
          }
        })
    },
    showError (error) {
      this.errorMessage = 'Add Account failed. (' + error + ')'
    },
    getDomainConfig () {
      let domainConfig = utils.getDomainConfig()
      this.domain = domainConfig.domain
    }
  },
  mounted () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// AccountUserInvite.vue?1550a3d0